import { createLogger } from 'redux-logger';
export default createLogger();